import React from 'react';
import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';

import {
  isWeb,
  getPageSameType,
  checkCurrentGalleryNeedPay,
} from '../../utils/util';
import NormalButton from './NormalButton';
import RootStore from '../../store/RootStore';

interface IDownloadButton {
  rootStore?: RootStore;
}
function DownloadButton(props: IDownloadButton) {
  const name = intl.get('Download-Pendent');
  const { galleryStore, wxuserStore } = props.rootStore!;

  const canShowGalleryButtons = () => {
    const result = getPageSameType(
      window.pageDetail.template || [],
      [],
      'photo'
    );
    return !!(result && result.length);
  };

  const isExhibitorPage = Number(window.pageDetail?.is_exhibitor) === 1;
  const hasPhotoData =
    galleryStore.total !== 0 ||
    galleryStore.list.length > 0 ||
    galleryStore.hotList.length > 0 ||
    galleryStore.personList.length > 0;

  const showBottom = function () {
    //  如果是模拟用户, 那么就需要先授权
    if (
      wxuserStore.user.is_mock &&
      Number(window.configDetail.active_on) == 1
    ) {
      wxuserStore.auth();
      return false;
    }

    const visibleEvent = new Event('PENDENT_FOLD');
    visibleEvent.data = 1;
    window.dispatchEvent(visibleEvent);
    galleryStore.setJigsaw({
      type: 'download',
      bottomShow: true,
    });
  };

  if (!canShowGalleryButtons()) {
    return null;
  }

  // 已登录的微信用户，并且 微信手机端才显示下载按钮
  // 目前发现微信PC端的小程序按钮无法显示，所以这里对这种情况不显示
  if (checkCurrentGalleryNeedPay()) {
    //  如果当前相册需要付费，不显示下载按钮, 后续逻辑更简洁
    return null;
  }

  // 展商详情页要求固定开放下载能力，不能因为列表初始化时序或环境识别被吞掉
  if (isExhibitorPage) {
    // total 初始值为 -1，表示列表尚在初始化阶段，此时也应允许先渲染按钮
    if (galleryStore.total === 0 && !hasPhotoData) {
      return null;
    }
    return <NormalButton onClick={showBottom}>{name}</NormalButton>;
  }

  if (
    (window.isweixin && !window.isweixinweb) ||
    isWeb()
    // || process.env.NODE_ENV === 'development'
  ) {
    if (galleryStore.total === 0 && !hasPhotoData) {
      // 无相册图片的页面不需要显示下载按钮
      return null;
    }
    return <NormalButton onClick={showBottom}>{name}</NormalButton>;
  }

  return null;
}
export default inject('rootStore')(observer(DownloadButton));